export const BOOTSTRAP_APP_DATA = 'BOOTSTRAP_APP_DATA'
export const BOOTSTRAP_APP_DATA_STARTED = 'BOOTSTRAP_APP_DATA_STARTED'
export const BOOTSTRAP_APP_DATA_SUCCESS = 'BOOTSTRAP_APP_DATA_SUCCESS'
export const BOOTSTRAP_APP_DATA_FAILED = 'BOOTSTRAP_APP_DATA_FAILED'
